import { recoveryPasswordErrorHandbook } from '~/models'
import type { TokenPackage } from '@/models'
import { HttpService } from '~/services/Http.service'
import { HttpErrorService } from '@/services/HttpError.service'

interface changePasswordPayload {
  code: string
  password: string
  passwordConfirmation: string
}

export class RecoveryPasswordService {
  private endpoint = '/users/recovery'
  private httpErrorService: HttpErrorService<
    keyof typeof recoveryPasswordErrorHandbook
  >

  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(
      recoveryPasswordErrorHandbook,
      'recovery',
    )
  }

  async requestEmail(email: string) {
    return await this.httpService
      .post(this.endpoint, {
        fetchConfig: {
          body: { email },
        },
        requestConfig: {
          forceRequest: true,
          cancellable: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, this.endpoint)
      })
  }

  async change(payload: changePasswordPayload) {
    const url = [this.endpoint, 'password'].join('/')

    return await this.httpService
      .post<TokenPackage>(url, {
        fetchConfig: {
          body: payload,
        },
        requestConfig: {
          forceRequest: true,
          cancellable: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, this.endpoint)
      })
  }

  async check(code: string) {
    const url = [this.endpoint, 'check'].join('/')

    return await this.httpService
      .get(url, {
        fetchConfig: {
          query: {
            code,
          },
        },
        requestConfig: {
          forceRequest: true,
          cancellable: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, this.endpoint)
      })
  }
}
